(function (Object) {
  typeof globalThis !== 'object' && (
    this ?
      get() :
      (Object.defineProperty(Object.prototype, '_T_', {
        configurable: true,
        get: get
      }), _T_)
  );
  function get() {
    var global = this || self;
    global.globalThis = global;
    delete Object.prototype._T_;
  }
}(Object));
export default globalThis;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@ungap/global-this/esm/index.js
// module id = 300
// module chunks = 0